// src/Modals/BirthdayListModal.tsx
import { Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

interface BirthdayUser {
  _id: string;
  email: string;
  phone: string;
  dateOfBirth: string;
  birthdayThisYear: string;
  age: number;
}

interface BirthdayListModalProps {
  open: boolean;
  onClose: () => void;
  birthdays: BirthdayUser[];
}

export default function BirthdayListModal({
  open,
  onClose,
  birthdays,
}: BirthdayListModalProps) {
  const formatDate = (dateString: string) => {
    return dayjs.utc(dateString).format("DD-MM-YYYY");
  };

  const getDaysLeftForBirthday = (birthday: string) => {
    // birthday format: "YYYY-MM-DD" or any valid date string
    const today = dayjs().startOf("day");
    let nextBirthday = dayjs(birthday).year(today.year());
    // If birthday has passed this year → set to next year
    if (nextBirthday.isBefore(today)) {
      nextBirthday = nextBirthday.add(1, "year");
    }
    const daysLeft = nextBirthday.diff(today, "day");
    return daysLeft === 1 || daysLeft === 0
      ? `${daysLeft} Day`
      : `${daysLeft} Days`;
  };

  return (
    <Modal className="modal birthday_list_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Upcoming Birthdays</h2>
            <button type="button" className="btn-close" onClick={onClose}>
              <CloseIcon />
            </button>
          </div>

          <div className="birthday_list">
            {birthdays.length === 0 ? (
              <p>No upcoming birthdays</p>
            ) : (
              <table className="data_table">
                <thead>
                  <tr>
                    <th>Email</th>
                    <th>DOB</th>
                    <th>Age</th>
                    <th>Days Left</th>
                  </tr>
                </thead>
                <tbody>
                  {birthdays.map((user) => (
                    <tr key={user._id}>
                      <td>{user.email || "N/A"}</td>
                      <td>{formatDate(user.dateOfBirth)}</td>
                      <td>{user.age}</td>
                      <td>{getDaysLeftForBirthday(user.birthdayThisYear)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
}
